<style lang="scss" scope>
.ivu-tabs .ivu-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  transition: opacity 0.3s;
  opacity: 1;
  outline: none;
}
.ivu-modal-wrap * {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.ivu-pb,
.ivu-pb-16 {
  padding-bottom: 16px !important;
}
.row[data-v-75eea3a4] {
  display: flex;
  border-bottom: 1px dashed #dee5e7;
  padding: 10px;
}
.row .col[data-v-75eea3a4] {
  width: 0;
  flex: 1;
  display: flex;
  padding: 0 15px;
}
.row .col .label[data-v-75eea3a4] {
  padding: 0 15px;
  flex-shrink: 0;
  width: 100px;
}
.row .col > div[data-v-75eea3a4] {
  padding: 14px 15px;
  font-weight: 700;

  .cell {
    text-align: center;
  }
}
</style>
<template>
  <div class="l-edit-dialog-box" style="padding-top:15px">
    <el-form>
        <!-- <div data-v-75eea3a4="" class="flex flex-wrap"><span data-v-75eea3a4="" class="ivu-avatar ivu-avatar-square ivu-avatar-image">
          <img style="width: 80px; height: 80px; line-height: 80px; font-size: 40px;" v-for="(item, index) in photo_list" :key="index" :src="item.photo" 
          @click="console.log('abc')" />
          <span class="l-action-separator">|</span>
        </span></div> -->
        
        <div v-for="(item,index) in this.photo_list" :key="item.id">
            <div>
            <h3>复查{{index+1}}</h3>
            <el-form-item label="" prop="item.id">
                <l-upload-img method="place_verifyPhoto" accept=".jpg,.png,.bmp" name="img" :on-success="(res)=>handleUploadSuccess(res,'review_photo',item.id)" :preview-url="item.photo[0]">
                </l-upload-img>
            </el-form-item>
            </div>
        </div>

        
    </el-form>
   
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>

export default {
  name: 'l-workphoto-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    place_id:{
      type: [String, Number],
      default: null
    },
    photo_list:{
      type: [String, Array],
      default: null
    },
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    },
  },
  data() {
    return {
      loading: false,//页面是否加载中
      //表单数据
      form_data: {
          id:0,
        review_photo:"",
        rectification_photo:""
      },
      facade_photo: "",
      danger_notification_photo: "",
      signature_photo: "",
      sign_for_photo: "",
      work_photo: "",
      activeName: 'first',
      info_data: {},
      percentage: 0,
      submitting: false,
      find:{},
      place_log:[],
      // log_id:0,
      // photo_list:{}
    }
  },
  methods: {
    getData() {
        this.loading = true;
        // this.form_data.review_photo=this.photoList;
        this.loading = false;
        console.log(this.photo_list);
        // this.$_invoke(`place_hiddenDetails`, { hidden_id: this.$props.id
        // }).then((ret) => {
        //     this.hiddenList = ret;
        //     this.form_data.photo=ret.photo;
        //     this.photo_preview = ret.photo;
        //     this.form_data.rectification_photo=ret.rectification_photo;
        //     this.rectification_photo_preview = ret.rectification_photo;
        // }).finally(() => {
          
        // });
    },
    //上传图标成功后的回调
    handleUploadSuccess(res, field,log_id) {
      this.form_data[field]=[res.data.photo];
      this[field + "_preview"] = res.data.photo;
      this.form_data.id=log_id;
      console.log(log_id);
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    handleSubmit(){
      // console.log(this.hiddenList);
      this.submitting = true;
      this.$_invoke('place_verifyUpdate',{
        "place_id":this.place_id,
        "id":this.form_data.id,
        "photo":this.form_data.review_photo,
      }).then(() => {
        this.$_msg.success('修改成功');
        this.$emit('on-success');
      }).finally(() => {
        this.submitting = false;
      })
    }
  },
}
</script>